module.exports = __webpack_public_path__ + "static/angularChat-dcf00a73e7b002211c9fb31b95695379.jpg";